import * as Phaser from "phaser"
import type { EnemyData, GameSprite } from "../../types"
import {
  type EnemyState,
  type EnemyStateContext,
  StatefulEnemyRuntime,
} from "../enemy-system"

type HornetPhase = "flying" | "retreat"

export class HornetDroneEnemy extends StatefulEnemyRuntime<HornetPhase> {
  public constructor(sprite: GameSprite, enemyData: EnemyData) {
    const states: EnemyState<HornetPhase>[] = [
      {
        name: "flying",
        behaviorState: "flying",
        animationState: "flying",
        update: (context) => this.updateFlying(context),
      },
      {
        name: "retreat",
        behaviorState: "flying",
        animationState: "flying",
        update: (context) => this.updateRetreat(context),
      },
    ]

    super(sprite, enemyData, "flying", states)
  }

  private updateFlying(
    context: EnemyStateContext<HornetPhase>,
  ): HornetPhase | null {
    const { sprite, enemyData, stateTime, scrollCompensation } = context
    const homeY = enemyData.homeY ?? sprite.y
    const spec = context.enemyDef?.movementSpec
    if (spec?.action !== "hornet-pattern") return null

    const sineTime = stateTime || context.time
    const wave =
      Math.sin((sineTime / spec.periodMs) * Math.PI * 2) * spec.amplitudeY
    sprite.y = Phaser.Math.Linear(sprite.y, homeY + wave, 0.12)
    enemyData.vx = scrollCompensation + spec.speedX

    if (sprite.x < 100) {
      return "retreat"
    }
    return null
  }

  private updateRetreat(
    context: EnemyStateContext<HornetPhase>,
  ): HornetPhase | null {
    const { sprite, enemyData, scrollCompensation, stateTime, time } = context
    const homeY = enemyData.homeY ?? sprite.y
    const spec = context.enemyDef?.movementSpec
    if (spec?.action !== "hornet-pattern") return null

    const sineTime = stateTime || time
    const wave =
      Math.sin((sineTime / spec.periodMs) * Math.PI * 2) * spec.amplitudeY
    sprite.y = Phaser.Math.Linear(sprite.y, homeY + wave, 0.08)
    enemyData.vx = scrollCompensation + 6.0

    return null
  }
}
